import http from '@/http'

const PATH = '/tools/bundles'

export default {
    /**
     * @param {BundleQuery} data
     * @returns {Promise<void>}
     */
    async listCharts (data) {
        try {
            const response = await http.get(`${PATH}/${data.id}/charts`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
